import * as React from "react"

export default (props: {text: string, show: boolean}) => (
    props.show ? <p style={{color: "#F00"}}>{props.text}</p> : null)
